import * as React from 'react';

const withNetworkDetector = () => {
  const [isDisconnected, setIsDisconnected] = React.useState(false);
  React.useEffect(() => {
    window.addEventListener('online', handleConnectionChange);
    window.addEventListener('offline', handleConnectionChange);
    return (): void => {
      window.removeEventListener('online', handleConnectionChange);
      window.removeEventListener('offline', handleConnectionChange);
    }
  }, []);
  const handleConnectionChange = (): void => {
    const condition = navigator.onLine ? 'online' : 'offline';
    if (condition === 'online') {
      const webPing = setInterval(() => {
        fetch('//google.com', { mode: 'no-cors' })
          .then(() => {
            setIsDisconnected(false);
            return clearInterval(webPing);
          }).catch(() => setIsDisconnected(true))
      }, 2000);
      return;
    }
    return setIsDisconnected(true);
  }
  return (
    <div>
      {isDisconnected &&
        (<div className="network-error">
          <span className="fa fa-warning" />  Internet connection lost
        </div>)
      }
    </div>
  );
}

export default withNetworkDetector;